import { useContext } from 'react';
import { FaStar, FaRegStar } from "react-icons/fa";
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, Inject, PieSeries, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-react-charts';
import { DashboardContext } from '../../context/DashboardContext';

export default function Perspectivas({ corFavorito, DiretrizEstrategica, tab }) {
    const { AdicionarGraficoFavorito } = useContext(DashboardContext)

    const retornaDescricao = (descricao) => {
        switch (descricao) {
            case "PERSPECTIVA FINANCEIRA":
                return "Financeira"
            case "PERSPECTIVA COOPERADO & CLIENTE":
                return "Cliente"
            case "PERSPECTIVA INTERNA":
                return "Interna"
            case "APRENDIZADO & CRESCIMENTO":
                return "Inovação"
            default:
                break;
        }
    }

    const onPointRender = (args) => {
        if (args.point.x == 'PERSPECTIVA FINANCEIRA') {
            args.fill = '#BFDE94';
        } else if (args.point.x == 'PERSPECTIVA COOPERADO & CLIENTE') {
            args.fill = '#9FCB61';
        } else if (args.point.x == 'PERSPECTIVA INTERNA') {
            args.fill = '#388933';
        } else if (args.point.x == 'APRENDIZADO & CRESCIMENTO') {
            args.fill = '#0F6631';
        } else if (args.point.x == 'APREDIZADO & CRESCIMENTO') {
            args.fill = '#0F6631';
        } else {
            args.fill = '#7f84e8';
        }
    };

    const retornaCor = (descricao) => {
        switch (descricao) {
            case "PERSPECTIVA FINANCEIRA":
                return "#BFDE94"
            case "PERSPECTIVA COOPERADO & CLIENTE":
                return "#9FCB61"
            case "PERSPECTIVA INTERNA":
                return "#388933"
            case "APRENDIZADO & CRESCIMENTO":
                return "#0F6631"
            case "APREDIZADO & CRESCIMENTO":
                return "#0F6631"
            default:
                break;
        }
    }

    const tooltipRender = (args) => {
        args.text = `${retornaDescricao(args.point.x)}: <b>${args.point.y}%</b>`;
    };

    const DiretrizEstrategicaFormatado = DiretrizEstrategica && DiretrizEstrategica.map(item => ({
        ...item,
        text: `${retornaDescricao(item.descricao)}: ${item.pesoPorcentagem}%`
    }));

    return (
        <>
            <h2 className="h2-bsc">
                <button onClick={() => AdicionarGraficoFavorito("Perspectivas")} className='btn-grafico'>{corFavorito("Perspectivas") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                <span style={{ fontWeight: '500' }}>Perspectivas</span>
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'start', marginTop: '10px', gap: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <AccumulationChartComponent
                        pointRender={onPointRender}
                        tooltip={{ enable: true, enableHtml: true }}
                        tooltipRender={tooltipRender}
                        width='700'
                        height='250'
                        center={{ y: '45%' }}
                        id={`${tab}-perspectivas`}
                    >
                        <Inject services={[PieSeries, AccumulationTooltip, AccumulationDataLabel]} />
                        <AccumulationSeriesCollectionDirective>
                            <AccumulationSeriesDirective
                                dataSource={DiretrizEstrategicaFormatado}
                                yName='pesoPorcentagem'
                                xName='descricao'
                                type='Pie'
                                pointColorMapping='fill'
                                dataLabel={{ visible: true, position: 'Outside', name: 'text', font: { fontWeight: '600' }, connectorStyle: { type: 'Curve' } }}
                            >
                            </AccumulationSeriesDirective>
                        </AccumulationSeriesCollectionDirective>
                    </AccumulationChartComponent>
                </div>
                <div className='span-bsc' style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    {DiretrizEstrategica?.map((item, index) => {
                        return (
                            <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '12px', height: '12px', marginRight: '8px', backgroundColor: retornaCor(item.descricao), borderRadius: '2px' }} />
                                <span className='span-bsc'> {retornaDescricao(item.descricao)}</span>
                                <span style={{ marginLeft: '5px', color: '#A1A1AA' }}>{item.pesoPorcentagem}%</span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}